import React, { useState } from "react";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Box, makeStyles, Collapse } from "@material-ui/core";

import Divider from "../Divider";

import "./collapsable-details.scss";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    width: "100%",
    border: "1px solid #c1d42f",
    borderRadius: 5,
    padding: 10
  },
  icon: {
    fontSize: "2.5rem",
    color: "#c1d42f"
  }
}));

export default function CollapsableDetails({ data }) {
  const [open, setOpen] = useState(true);
  const classes = useStyles();
  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <Box classes={{ root: classes.mainContainer }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <div className="details-container-title">Detalle de cobertura</div>
        <Box onClick={handleClick}>
          {open ? (
            <ExpandLess classes={{ root: classes.icon }} />
          ) : (
            <ExpandMore classes={{ root: classes.icon }} />
          )}
        </Box>
      </Box>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Divider my="16px" />
        {data &&
          data.texts.map((item) => {
            return (
              <div key={item.title} className="details-text-title">
                <div>{item.title}</div>
                <div className="details-text">
                  <p style={{ margin: "0" }}>{item.description}</p>
                </div>
              </div>
            );
          })}
      </Collapse>
    </Box>
  );
}
